const { h, render, Component } = require('preact');
const Web2018Helper = require('../../../helper')

class CheckInInfo extends Component {
  constructor(props) {
    super(props);
    this.getCheckInInfo = this.getCheckInInfo.bind(this);
  }

  getCheckInInfo(orderDetails){
    if(orderDetails && orderDetails.travelBookingInfo && orderDetails.travelBookingInfo.reservation && orderDetails.travelBookingInfo.reservation.formattedCheckInDate)
      return orderDetails.travelBookingInfo.reservation.formattedCheckInDate;
    else if(orderDetails && orderDetails.groupons && orderDetails.groupons[0] && orderDetails.groupons[0].extraAttributes && orderDetails.groupons[0].extraAttributes.formattedCheckIn)
      return orderDetails.groupons[0].extraAttributes.formattedCheckIn;
    else
      return null;
  }

  render() {
    let checkInInfo = this.getCheckInInfo(this.props.orderDetails);
    if (checkInInfo){
      return (
        <tr>
          <td>{I18n.translate("js.modules.web_2018.check_in")}:</td>
          <td>{Web2018Helper.getDateStringWithDay(checkInInfo)}</td>
        </tr>
      );
    }
    return null;
  }
}
module.exports = CheckInInfo
